const AuthController = {
    config: {
        container: '.auth-container',
        title: '.auth-modal__title',
        subtitle: '.auth-modal__subtitle',
        screen: '.auth-screen',
        screenActive: 'auth-screen_active',
        switcherBtn: '.auth-switcher__btn',
        switcherBtnActive: 'auth-switcher__btn_active',
        field: '.auth-field',
        fieldError: 'auth-field_error',
        fieldErrorText: '.auth-field__error',
        fieldInput: '.auth-field__input',
        globalError: '.auth-error',
        globalErrorActive: 'auth-error_active',
        loader: '.auth-loader',
        loaderActive: 'auth-loader_active',
    },

    init() {
        const self = this;
        const { config } = self;

        $(document).on('click', config.switcherBtn, function (e) {
            e.preventDefault();
            const screen = $(this).data('screen');
            if (screen) {
                self.switchScreen(screen);
            }
        });

        $(document).on('click', '.js-auth-forgot', function (e) {
            e.preventDefault();
            self.switchScreen('remind');
        });

        $(document).on('click', '.js-auth-back-login', function (e) {
            e.preventDefault();
            self.switchScreen('login');
        });

        $(document).on('click', '.js-login-user', function () {
            window.Modal.show('auth');

            self.updateTitleFromActiveScreen();
        });

        $(document).on('click', '.logout-user', function () {
            self.logout();
        });

        $(document).on('click', '.auth-modal-background', function () {
            window.Modal.hide($('#auth-modal'));
        });

        $(document).on('focus', config.fieldInput, function () {
            $(this).closest(config.field).removeClass(config.fieldError);
            $(config.globalError).removeClass(config.globalErrorActive);
        });

        $(document).on('change', '.auth-checkbox input[type="checkbox"]', function () {
            $(this).closest(config.field).removeClass(config.fieldError);
            $(config.globalError).removeClass(config.globalErrorActive);
        });

        self.initPage();
        self.updateTitleFromActiveScreen();
    },

    initPage() {
        const $page = $('.auth-page');
        if (!$page.length) return;

        const activeScreen = $page.data('active-screen');
        if (activeScreen) {
            this.switchScreen(activeScreen);
        }
    },

    updateTitleFromActiveScreen() {
        const { config } = this;
        const $container = $(config.container);
        const $activeScreen = $container.find('.' + config.screenActive);

        if ($activeScreen.length) {
            $container.find(config.title).text($activeScreen.data('title') || '');
            $container.find(config.subtitle).text($activeScreen.data('subtitle') || '');
        }
    },

    switchScreen(screenName) {
        const { config } = this;
        const $container = $(config.container);

        $container.find(config.screen).removeClass(config.screenActive);
        const $activeScreen = $container.find('[data-screen="' + screenName + '"].auth-screen');
        $activeScreen.addClass(config.screenActive);

        $container.find(config.switcherBtn).removeClass(config.switcherBtnActive);
        $container.find(config.switcherBtn + '[data-screen="' + screenName + '"]').addClass(config.switcherBtnActive);

        $container.find(config.title).text($activeScreen.data('title') || '');
        $container.find(config.subtitle).text($activeScreen.data('subtitle') || '');

        $container.find(config.field).removeClass(config.fieldError);
        $container.find(config.globalError).removeClass(config.globalErrorActive);
    },

    setFieldError(inputSelector, message) {
        const { config } = this;
        const $field = $(inputSelector).closest(config.field);
        $field.addClass(config.fieldError);
        $field.find(config.fieldErrorText).text(message);
    },

    handleErrors(errors, fieldMap) {
        const self = this;
        let hasFieldError = false;

        for (const key in errors) {
            const lowerKey = key.toLowerCase();
            const inputSelector = fieldMap[lowerKey];
            if (inputSelector) {
                self.setFieldError(inputSelector, errors[key]);
                hasFieldError = true;
            }
        }

        const globalMessages = [];
        for (const key in errors) {
            if (!fieldMap[key.toLowerCase()]) {
                globalMessages.push(errors[key]);
            }
        }
        if (globalMessages.length) {
            self.showGlobalError(globalMessages.join('<br>'));
        } else if (!hasFieldError) {
            self.showGlobalError(Object.values(errors).join('<br>'));
        }
    },

    clearErrors() {
        const { config } = this;
        const $container = $(config.container);
        $container.find(config.field).removeClass(config.fieldError);
        $container.find(config.globalError).removeClass(config.globalErrorActive);
    },

    withCsrf(data) {
        const csrfName = $('meta[name="csrf-param"]').attr('content');
        data[csrfName] = $('meta[name="csrf-token"]').attr('content');
        return data;
    },

    showGlobalError(message) {
        const { config } = this;
        $(config.globalError).html(message).addClass(config.globalErrorActive);
    },

    showLoader() {
        const { config } = this;
        $(config.loader).addClass(config.loaderActive);
    },

    hideLoader() {
        const { config } = this;
        $(config.loader).removeClass(config.loaderActive);
    },

    logout() {
        $.ajax({
            url: '/users/logout',
            method: 'POST',
            data: this.withCsrf({}),
            dataType: 'json',
        }).done(function () {
            window.location.reload();
        });
    },
};

const AuthLoginController = {
    config: {
        form: '#login-form',
        loginInput: '#login-form-login',
        passwordInput: '#login-form-password',
    },

    init() {
        const self = this;
        const { config } = self;

        $(document).on('submit', config.form, function (e) {
            e.preventDefault();
            self.submitForm();
        });
    },

    validate() {
        const { config } = this;
        let valid = true;

        const login = $(config.loginInput).val().trim();
        const password = $(config.passwordInput).val().trim();

        if (!login) {
            AuthController.setFieldError(config.loginInput, Yii.t('Required field'));
            valid = false;
        }

        if (!password) {
            AuthController.setFieldError(config.passwordInput, Yii.t('Required field'));
            valid = false;
        }

        return valid;
    },

    submitForm() {
        const self = this;
        const { config } = self;

        AuthController.clearErrors();

        if (!self.validate()) {
            return;
        }

        const $form = $(config.form);
        const formAction = $form.attr('action');

        AuthController.showLoader();

        getReCaptchaToken(function (token) {
            const formData = Object.fromEntries(new FormData($form[0]));
            formData.token = token;
            const data = AuthController.withCsrf(formData);

            $.ajax({
                url: formAction,
                method: 'POST',
                data: data,
                dataType: 'json',
            }).done(function (response) {
                if (response.errors) {
                    AuthController.handleErrors(response.errors, {
                        login: config.loginInput,
                        password: config.passwordInput,
                    });
                    return;
                }
                window.location.reload();
            }).fail(function () {
                AuthController.showGlobalError(Yii.t('Server error. Please try again later.'));
            }).always(function () {
                AuthController.hideLoader();
            });
        }, 'login');
    },
};

const AuthRegistrationController = {
    config: {
        form: '#registration-form',
        emailInput: '#registration-form-email',
        passwordInput: '#registration-form-password',
        confirmPasswordInput: '#registration-form-confirm-password',
        personalDataCheckbox: '#registration-form-personal-data',
    },

    init() {
        const self = this;
        const { config } = self;

        $(document).on('submit', config.form, function (e) {
            e.preventDefault();
            self.submitForm();
        });
    },

    validate() {
        const { config } = this;
        let valid = true;

        const email = $(config.emailInput).val().trim();
        const password = $(config.passwordInput).val();
        const confirmPassword = $(config.confirmPasswordInput).val();
        const personalData = $(config.personalDataCheckbox).is(':checked');

        if (!email) {
            AuthController.setFieldError(config.emailInput, Yii.t('Required field'));
            valid = false;
        } else if (!/[^@]+@[^@]+\.[^@]+/.test(email)) {
            AuthController.setFieldError(config.emailInput, Yii.t('Invalid email'));
            valid = false;
        }

        if (!password) {
            AuthController.setFieldError(config.passwordInput, Yii.t('Required field'));
            valid = false;
        } else if (password.length < 6 || password.length > 32) {
            AuthController.setFieldError(config.passwordInput, Yii.t('Password must be 6 to 32 characters'));
            valid = false;
        }

        if (!confirmPassword) {
            AuthController.setFieldError(config.confirmPasswordInput, Yii.t('Required field'));
            valid = false;
        } else if (password && confirmPassword !== password) {
            AuthController.setFieldError(config.confirmPasswordInput, Yii.t('Passwords do not match'));
            valid = false;
        }

        if (!personalData) {
            AuthController.setFieldError(config.personalDataCheckbox, Yii.t('Consent is required'));
            valid = false;
        }

        return valid;
    },

    submitForm() {
        const self = this;
        const { config } = self;

        AuthController.clearErrors();

        if (!self.validate()) {
            return;
        }

        const $form = $(config.form);
        const formAction = $form.attr('action');

        AuthController.showLoader();

        getReCaptchaToken(function (token) {
            const formData = Object.fromEntries(new FormData($form[0]));
            formData.token = token;
            const data = AuthController.withCsrf(formData);

            $.ajax({
                url: formAction,
                method: 'POST',
                data: data,
                dataType: 'json',
            }).done(function (response) {
                if (response.errors) {
                    AuthController.handleErrors(response.errors, {
                        email: config.emailInput,
                        password: config.passwordInput,
                        confirmpassword: config.confirmPasswordInput,
                    });
                    return;
                }

                window.Modal.hide($('#auth-modal'));
                window.Modal.show('message', {message: response.message}, true);

                if (window.ym && window.ymCounters && window.ymCounters.companyID) {
                    window.ym(window.ymCounters.companyID, 'reachGoal', 'UserIsRegistered');
                }
            }).fail(function () {
                AuthController.showGlobalError(Yii.t('Server error. Please try again later.'));
            }).always(function () {
                AuthController.hideLoader();
            });
        }, 'registration');
    },
};

const AuthRemindController = {
    config: {
        form: '#remind-form',
        emailInput: '#remind-form-email',
    },

    init() {
        const self = this;
        const { config } = self;

        $(document).on('submit', config.form, function (e) {
            e.preventDefault();
            self.submitForm();
        });
    },

    validate() {
        const { config } = this;
        let valid = true;

        const email = $(config.emailInput).val().trim();

        if (!email) {
            AuthController.setFieldError(config.emailInput, Yii.t('Required field'));
            valid = false;
        } else if (!/[^@]+@[^@]+\.[^@]+/.test(email)) {
            AuthController.setFieldError(config.emailInput, Yii.t('Invalid email'));
            valid = false;
        }

        return valid;
    },

    submitForm() {
        const self = this;
        const { config } = self;

        AuthController.clearErrors();

        if (!self.validate()) {
            return;
        }

        const $form = $(config.form);
        const formAction = $form.attr('action');

        AuthController.showLoader();

        getReCaptchaToken(function (token) {
            const formData = Object.fromEntries(new FormData($form[0]));
            formData.token = token;
            const data = AuthController.withCsrf(formData);

            $.ajax({
                url: formAction,
                method: 'POST',
                data: data,
                dataType: 'json',
            }).done(function (response) {
                if (response.errors) {
                    AuthController.handleErrors(response.errors, {
                        email: config.emailInput,
                    });
                    return;
                }

                window.Modal.hide($('#auth-modal'));
                window.Modal.show('message', {message: response.message});
            }).fail(function () {
                AuthController.showGlobalError(Yii.t('Server error. Please try again later.'));
            }).always(function () {
                AuthController.hideLoader();
            });
        }, 'remind');
    },
};

window.sending = false;
function oauth(token) {
    if (window.sending) {
        return false;
    }

    window.sending = true;
    var data = AuthController.withCsrf({token: token});

    $.ajax({
        url: '/users/oauth',
        method: 'POST',
        data: data,
        dataType: 'json',
    }).done(function (response) {
        if (response.errors) {
            var message = [];
            for (var key in response.errors) {
                message.push(response.errors[key]);
            }
            window.Modal.show('message', {message: message.join('<br>')});
            window.sending = false;
            return;
        }

        window.location.reload();
    }).fail(function () {
        window.sending = false;
    });
}

$(function () {
    if ($('#auth').length || $('.auth-container').length) {
        AuthController.init();
        AuthLoginController.init();
        AuthRegistrationController.init();
        AuthRemindController.init();
    }
});
